@switch (change.changeType) {
    @case (changeType.Unchanged) {
        <span data-qa-id="unchanged-value">{{ change.originalValue | nullDash }}
            @if (change.originalValue !== null) {
                <span> year(s)</span>
            }
        </span>
    }
    @case (changeType.Changed) {
        <div class="value-panel">
            <span class="original-value" data-qa-id="original-year-value">{{ change.originalValue | nullDash }}</span>
            <span class="new-value" data-qa-id="new-year-value">{{ change.newValue | nullDash }}</span>
            <span> year(s)</span>
        </div>
    }
}

@if (noteChange && noteChange.originalValue || noteChange.newValue) {
    @switch (change.changeType) {
        @case (changeType.Unchanged) {
            <div data-qa-id="unchanged-note-value" class="note"> Note: {{ noteChange.originalValue | nullDash }}</div>
        }
        @case (changeType.Changed) {
            <div class="value-panel note">
                Note: <span class="original-value" data-qa-id="original-note-value">{{ noteChange.originalValue | nullDash }}</span>
                <span class="new-value" data-qa-id="new-note-value">{{ noteChange.newValue | nullDash }}</span>
            </div>
        }
    }
}
